import { render, staticRenderFns } from "./FormFour.vue?vue&type=template&id=b4016598&scoped=true"
import script from "./FormFour.vue?vue&type=script&lang=js"
export * from "./FormFour.vue?vue&type=script&lang=js"
import style0 from "./FormFour.vue?vue&type=style&index=0&id=b4016598&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4016598",
  null
  
)

export default component.exports